/* eslint-disable */
import React, { useState, useEffect, useMemo } from "react";

import {
  Grid,
  Typography,
  Box,
  CircularProgress,
  TextField,
  Divider,
  Tabs,
  Tab,
} from "@material-ui/core";
import AssignmentIcon from "@material-ui/icons/Assignment";
import RateReviewOutlinedIcon from '@material-ui/icons/RateReviewOutlined';

import { useTranslation } from "react-i18next";
import { useParams, Link } from "react-router-dom";

import Button from "../../../../components/Button";
import Modal from "../../../../components/Modal";
import Snackbar from "../../../../components/Snackbar";

import {
  IMAGE,
  MULTIPLE_IMAGE_QUESTION,
} from "../../../../utils/const/pageTypes";

import {
  postTeleauditBinaryResponse,
  deactivateTeleauditBinaryResponses,
} from "../../../../requests/api/teleaudit-binary-response";
import {
  getSurvey,
  postSurveyTeleaudit,
  getQuestionResponseById,
  putQuestionReponseTeleauditStatus,
} from "../../../../requests/api/question-response";
import getTeleauditKpiByQuestion from "../../../../requests/api/teleaudit-kpi";

import getImagesByQuestionResponseId from "../../../../requests/api/question-response-image";
import postQuestionResponseImageVectors from "../../../../requests/api/question-response-image-vector";
import getBrands from "../../../../requests/api/brand";

import TeleauditCarousel from "./Components/teleauditCarousel";
import BinaryTable from "./Components/binaryTable";
import SurveyImage from "./Components/surveyImage";
import ColorButtons from "./Components/ColorButtons";
import PolygonAreasTable from "./Components/PolygonAreasTable";
import {
  PAINT_ITEMS_CONFIG,
  SOS_AREA_REQUIRED_BRAND,
  formatPhotosMissingRequiredBrand,
  getPhotosMissingRequiredBrand,
} from "./Components/brandColorOptions";
import SurveySection from "./Components/SurveySection";
import ReferenceImage from "./Components/ReferenceImage";
import useStyles from "./styles";

const GENERAL_SUBCATEGORY = "general";

// HARDCODE de orden y filtro de brands
const getTeleauditBrandOptions = (brands = [], type, competitionLabel) => {
  const hasProjectBrands = brands.some((brand) => {
    const brandProjectId = brand.projectId ?? brand.project_id;
    return brandProjectId !== null && brandProjectId !== undefined;
  });
  const hideProducts = ["sos", "sosarea"].includes(type) && hasProjectBrands;
  const filteredBrands = brands.filter((brand) => (
    (type === "sosarea" && brand.id === SOS_AREA_REQUIRED_BRAND.brandId)
    || (
      brand.name !== "None"
      && (!hideProducts || brand.name !== "Productos")
    )
  ));
  const competitionBrands = filteredBrands.filter((brand) => brand.name === "Competencia");
  const otherBrands = filteredBrands.filter((brand) => brand.name !== "Competencia");
  const getBrandLabel = (brand) => (
    brand.competing === true
      ? `${brand.name} - (${competitionLabel})`
      : brand.name
  );

  return [
    { value: 0, label: "-----" },
    ...otherBrands.map((brand) => ({
      value: brand.id,
      label: getBrandLabel(brand),
    })),
    ...competitionBrands.map((brand) => ({
      value: brand.id,
      label: getBrandLabel(brand),
    })),
  ];
};

const createEmptyColorOptions = () => PAINT_ITEMS_CONFIG.reduce(
  (colorOptions, item) => ({ ...colorOptions, [item.key]: 0 }),
  {},
);

const removeScopedVectorsByColor = (vectors, colorName, isVisible) => (
  vectors.filter((vector) => !isVisible(vector) || vector.color !== colorName)
);

const TeleauditAll = () => {
  const { t, i18n } = useTranslation();
  const styles = useStyles();

  const [lineList, setLineList] = useState({});
  const [questionType, setQuestionType] = useState("");
  const [teleauditKpis, setTeleauditKpis] = useState(null);
  const [questionResponse, setQuestionResponse] = useState(null);
  const [startDate, setStartDate] = useState(null);
  // const [category, setCategory] = useState(null);
  const [switchValues, setSwitchValues] = useState({});
  const [notAnswered, setNotAnswered] = useState(0);
  const [requiredBrandError, setRequiredBrandError] = useState("");
  const [saving, setSaving] = useState(false);
  const [buttonColor, setButtonColor] = useState(null);
  const [erase, setErase] = useState(false);
  const [drawingType, setDrawingType] = useState("line");
  const [listImages, setListImages] = useState({});
  const [loading, setLoading] = useState(true);
  const [currentImage, setCurrentImage] = useState({});
  const [saveLoader, setSaveLoader] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [companyLogo, setCompanyLogo] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [answersSubmitted, setAnswersSubmitted] = useState(false);
  const [polygonMode] = useState(true);
  const [polygonCache, setPolygonCache] = useState({});
  const [polygonColor, setPolygonColor] = useState(null);
  const [teleauditStatus, setTeleauditStatus] = useState("pending");
  const [binaryKpis, setBinaryKpis] = useState([]);
  const [binaryKpiCurrentImage, setBinaryKpiCurrentImage] = useState([]);
  const [comment, setComment] = useState("");
  const [showSaveTest, setShowSaveTest] = useState(true);
  const [polygonAreas, setPolygonAreas] = useState({
    areasByColor: {},
  });
  const [colorOptionsByScope, setColorOptionsByScope] = useState({});
  const [brandOptions, setBrandOptions] = useState([
    { value: 0, label: "-----" },
  ]);
  const arrayQuestions = [IMAGE, MULTIPLE_IMAGE_QUESTION];
  const { taskResponseId, questionResponseId, type } = useParams();
  const [selectedSubCategory, setSelectedSubCategory] = useState(GENERAL_SUBCATEGORY);

  useEffect(() => {
    if (questionResponse && teleauditStatus !== "done") {
      setStartDate(new Date().toISOString());
      console.log(new Date().toISOString());
    }
  }, [questionResponse, teleauditStatus]);
  const subCategories = questionResponse?.Question?.Category?.SubCategories || [];

  const isVectorForSubCategory = (vector, subCategoryId) => (
    subCategoryId === GENERAL_SUBCATEGORY
      ? vector.subCategoryId === null || vector.subCategoryId === undefined
      : Number(vector.subCategoryId) === Number(subCategoryId)
  );

  const isVisibleForSelectedSubCategory = (vector) => (
    isVectorForSubCategory(vector, selectedSubCategory)
  );

  const getVisibleVectors = (vectors = []) => vectors.filter(isVisibleForSelectedSubCategory);

  const getSubCategoryKey = (subCategoryId) => (
    subCategoryId === null
    || subCategoryId === undefined
    || subCategoryId === GENERAL_SUBCATEGORY
      ? GENERAL_SUBCATEGORY
      : String(subCategoryId)
  );

  // En SOS Área un scope sin datos guardados arranca con la marca obligatoria en el primer color.
  const createScopeColorOptions = () => (
    type === "sosarea"
      ? {
        ...createEmptyColorOptions(),
        [SOS_AREA_REQUIRED_BRAND.defaultColor]: SOS_AREA_REQUIRED_BRAND.brandId,
      }
      : createEmptyColorOptions()
  );

  const getColorOptionsForScope = (imageId, subCategoryId) => (
    colorOptionsByScope[imageId]?.[getSubCategoryKey(subCategoryId)]
      || createScopeColorOptions()
  );

  // Asigna la marca obligatoria en cada scope con trazos guardados sin pisar lo existente:
  // si ya tiene color se conserva; si no, toma el primer color sin marca y sin trazos.
  const assignRequiredBrandByScope = (imageOptions, imageVectors) => {
    const scopeKeys = [...new Set(
      imageVectors.map((vector) => getSubCategoryKey(vector.subCategoryId)),
    )];

    return scopeKeys.reduce((optionsBySubCategory, subCategoryKey) => {
      const scopeOptions = optionsBySubCategory[subCategoryKey] || createEmptyColorOptions();
      if (Object.values(scopeOptions).includes(SOS_AREA_REQUIRED_BRAND.brandId)) {
        return { ...optionsBySubCategory, [subCategoryKey]: scopeOptions };
      }

      const freeColor = PAINT_ITEMS_CONFIG.find((item) => (
        !scopeOptions[item.key]
        && !imageVectors.some((vector) => (
          getSubCategoryKey(vector.subCategoryId) === subCategoryKey
          && vector.color === item.key
        ))
      ))?.key;

      return {
        ...optionsBySubCategory,
        [subCategoryKey]: freeColor
          ? { ...scopeOptions, [freeColor]: SOS_AREA_REQUIRED_BRAND.brandId }
          : scopeOptions,
      };
    }, imageOptions);
  };

  const colorOptions = useMemo(
    () => getColorOptionsForScope(currentImage.id, selectedSubCategory),
    [colorOptionsByScope, currentImage.id, selectedSubCategory],
  );

  // La marca es una propiedad del color dentro de su scope (imagen + subcategoría),
  // no del vector: así cambiar la marca no altera las longitudes ya dibujadas.
  const resolveVectorBrand = (imageId, vector) => (
    getColorOptionsForScope(imageId, vector.subCategoryId)[vector.color] || 0
  );

  // Los trazos visibles se derivan del cache para que nunca se mezclen entre
  // fotos ni entre subcategorías.
  const lines = useMemo(
    () => getVisibleVectors(lineList[currentImage.id] || []),
    [lineList, currentImage.id, selectedSubCategory],
  );

  const setColorOptions = (nextColorOptions) => {
    if (!currentImage.id) return;

    const subCategoryKey = getSubCategoryKey(selectedSubCategory);
    setColorOptionsByScope((prev) => {
      const imageOptions = prev[currentImage.id] || {};
      const previousOptions = imageOptions[subCategoryKey] || createScopeColorOptions();
      const nextOptions = typeof nextColorOptions === "function"
        ? nextColorOptions(previousOptions)
        : nextColorOptions;

      return {
        ...prev,
        [currentImage.id]: {
          ...imageOptions,
          [subCategoryKey]: nextOptions,
        },
      };
    });
  };

  const handleSubCategoryChange = (_, value) => {
    setSelectedSubCategory(value);
    setButtonColor(null);
    setPolygonColor(null);
  };

  useEffect(() => {
    const projectId = questionResponse?.SurveyResponse?.Survey?.projectId;
    if (projectId === undefined || projectId === null) return;

    const getBrandOptions = async () => {
      const response = await getBrands(projectId);
      if (response.success) {
        const brands = response.data.data.brands || [];
        setBrandOptions(getTeleauditBrandOptions(brands, type, t("common.competition")));
      }
    };

    getBrandOptions();
  }, [questionResponse, type, t]);

  useEffect(() => {
    const getTeleauditSurvey = async (id) => {
      const response = await getSurvey({ id });
      var questionsReview = response.data.data.survey.Questions;
      if (questionsReview.length === 0) return;

      let show = true;

      const updatedQuestions = questionsReview.map((q) => {
        var questionShow = show;
        if (q.OriginalQuestionLogics.length > 1) {
          show = false;
        }

        return { ...q, show: questionShow };
      });

      if (show === false) {
        setShowSaveTest(false);
      }
      setQuestions(updatedQuestions);
    };

    const getQuestionResponse = async () => {
      const response = await getQuestionResponseById({ questionResponseId });
      if (response.data.data.questionResponse) {
        const surveyId =
          response.data.data.questionResponse.Question.surveyTeleauditId;
        if (surveyId != null) {
          getTeleauditSurvey(surveyId);
        }
        setQuestionType(response.data.data.questionResponse.Question.type);
        setQuestionResponse(response.data.data.questionResponse);
        setTeleauditStatus(response.data.data.questionResponse.teleauditStatus);
        setComment(response.data.data.questionResponse.commentTeleaudit);
      }
      // if (response.data.data.category) {
      //   setCategory(response.data.data.category);
      // }
      if (
        ["not-required"].includes(
          response.data.data.questionResponse.teleauditStatus,
        )
      ) {
        window.location.href = "/home";
      }
    };

    const findSurveyResponseImages = async () => {
      const response = await getImagesByQuestionResponseId({
        questionResponseId,
      });
      if (response.success) {
        const { data } = response.data;
        setListImages(data);
        const newObject = {};
        data.forEach((image) => {
          const vectors = [];
          const imageVectors = image.QuestionResponseImageVectors || [];
          if (imageVectors.length > 0) {
            for (
              let i = 0;
              i < imageVectors.length;
              i += 1
            ) {
              const vector = imageVectors[i];
              const brandId = Number(vector.brandId ?? vector.brand_id) || 0;
              var newLine;
              if (type === "sos") {
                newLine = {
                  id: vector.id,
                  x1: vector.startX,
                  y1: vector.startY,
                  x2: vector.endX,
                  y2: vector.endY,
                  color: vector.color,
                  brand: brandId,
                  subCategoryId: vector.subCategoryId ?? null,
                  guardada: true,
                };
              } else if (type === "sosarea") {
                newLine = {
                  id: vector.id,
                  color: vector.color,
                  points: vector.jsonPolygon,
                  brand: brandId,
                  subCategoryId: vector.subCategoryId ?? null,
                  guardada: true,
                };
              }
              vectors.push(newLine);
            }
          }
          newObject[image.id] = vectors;
        });
        const restoredColorOptionsByScope = data.reduce((optionsByScope, image) => {
          const imageOptions = (image.QuestionResponseImageVectors || []).reduce(
            (optionsBySubCategory, vector) => {
              const brandId = Number(vector.brandId ?? vector.brand_id) || 0;
              if (!vector.color || brandId <= 0) return optionsBySubCategory;

              const subCategoryKey = getSubCategoryKey(vector.subCategoryId);
              return {
                ...optionsBySubCategory,
                [subCategoryKey]: {
                  ...(optionsBySubCategory[subCategoryKey] || createEmptyColorOptions()),
                  [vector.color]: brandId,
                },
              };
            },
            {},
          );

          return {
            ...optionsByScope,
            [image.id]: type === "sosarea"
              ? assignRequiredBrandByScope(
                imageOptions,
                image.QuestionResponseImageVectors || [],
              )
              : imageOptions,
          };
        }, {});
        setColorOptionsByScope(restoredColorOptionsByScope);

        if (type === "sos") {
          setLineList(newObject);
        } else if (type === "sosarea") {
          setPolygonCache(newObject);
        }
      } else {
        window.location.href = "/home";
      }
    };
    findSurveyResponseImages();
    getQuestionResponse();

    if (type === "encuesta") {
      setTimeout(() => {
        setLoading(false);
      }, 1000);
    }
  }, []);

  useEffect(() => {
    if (listImages.length > 0 && !currentImage.id) {
      setCurrentImage(listImages[0]);
    }
  }, [listImages, currentImage.id]);

  // Se muestra la compañía dueña del proyecto de la survey, no la del portal.
  useEffect(() => {
    const projectCompany = questionResponse?.SurveyResponse?.Survey?.Project?.Company;
    if (!projectCompany) return;

    setCompanyName(projectCompany.name);
    setCompanyLogo(projectCompany.logoUrl);
  }, [questionResponse]);

  useEffect(() => {
    if (questionResponse) {
      const getTeleauditKpis = async () => {
        const { questionId } = questionResponse;
        const response = await getTeleauditKpiByQuestion({
          questionId,
          questionResponseId,
        });
        if (type === "os") {
          var kpiBinarys = response.data.teleauditBinaryKpis.filter(
            (item) => item.KpiDetail.teleauditType === "binary",
          );
          var kpiBinaryResponses = kpiBinarys.map((item) => {
            var response;
            if (item.TeleauditBinaryResponse) {
              response = item.TeleauditBinaryResponse.score ? 1 : 0;
            } else {
              response = null;
            }
            return { id: item.id, response };
          });
          setBinaryKpiCurrentImage(kpiBinaryResponses);
          setBinaryKpis(kpiBinarys);
        }
        const teleauditBinaryKpisObject = {};
        response.data.teleauditBinaryKpis
          .filter((item) => item.KpiDetail.teleauditType !== "binary")
          .forEach((element) => {
            teleauditBinaryKpisObject[element.id] = element;
          });
        if (arrayQuestions.includes(questionResponse.Question.type)) {
          setTeleauditKpis({
            binary:
              Object.keys(teleauditBinaryKpisObject).length !== 0
                ? teleauditBinaryKpisObject
                : null,
          });
        } else {
          setTeleauditKpis({ binary: teleauditBinaryKpisObject });
        }
      };
      getTeleauditKpis();
    }
  }, [questionResponse]);

  useEffect(() => {
    if (teleauditKpis && teleauditKpis.binary) {
      const switchValuesObject = {};
      Object.keys(teleauditKpis.binary).forEach((item) => {
        switchValuesObject[item] = false;
      });
      setSwitchValues(switchValuesObject);
      setLoading(false);
    } else if (teleauditKpis && !teleauditKpis.binary) {
      setLoading(false);
    }
  }, [teleauditKpis]);

  // Recalcular áreas cuando cambien los polígonos, la imagen o la subcategoría
  useEffect(() => {
    recalcularAreas();
  }, [polygonCache, currentImage, selectedSubCategory]);

  const saveAll = async () => {
    await setSaveLoader("loading");
    const teleauditStatus = "done";
    // Save vectors data of TA.
    // Usamos el tipo de dibujo actual para guardar
    const currentShareType =
      type === "sosarea" || drawingType !== "line"
        ? "volumetric-share"
        : "linear-share";

    const lineListForSave =
      currentShareType === "linear-share"
        ? Object.entries(lineList).reduce(
            (updatedLineList, [imageId, imageLines]) => ({
              ...updatedLineList,
              [imageId]: imageLines.map((line) => ({
                ...line,
                brand: resolveVectorBrand(imageId, line),
                subCategoryId: line.subCategoryId ?? null,
                length: Math.hypot(line.x2 - line.x1, line.y2 - line.y1),
                guardada: false,
              })),
            }),
            {},
          )
        : {};

    const polygonAreasForSave =
      currentShareType === "volumetric-share" && Array.isArray(listImages)
        ? listImages.reduce(
            (updatedPolygonAreas, image) => ({
              ...updatedPolygonAreas,
              [image.id]: (polygonCache[image.id] || []).map((polygon) => ({
                ...polygon,
                brand: resolveVectorBrand(image.id, polygon),
                subCategoryId: polygon.subCategoryId ?? null,
                length: calcularArea(polygon.points),
                guardada: false,
              })),
            }),
            {},
          )
        : polygonCache;

    // Mostrar en consola los datos que se van a guardar
    if (window.showSaveData) {
      window.showSaveData = false; // Evitar múltiples logs
    }

    if (type === "sos" || type === "sosarea") {
      const response = await postQuestionResponseImageVectors({
        lineList: lineListForSave,
        shareType: currentShareType,
        polygonAreas: polygonAreasForSave,
      });
      if (!response.success) {
        setSaveLoader("loaded");
        return;
      }
    }
    var commentTeleaudit = comment;
    await putQuestionReponseTeleauditStatus({
      questionResponseId,
      teleauditStatus,
      taskResponseId,
      // When all the question responses are done, the task instance is done too
      last: notAnswered === 0,
      commentTeleaudit,
      type,
      startDate,
      finishDate: new Date().toISOString(),
    });
    if (questionResponse.teleauditStatus === "reaudit") {
      await deactivateTeleauditBinaryResponses({
        questionResponseId: questionResponse.id,
      });
    }
    if (type === "os") {
      binaryKpiCurrentImage.forEach(async (element) => {
        await postTeleauditBinaryResponse(
          element.id,
          questionResponseId,
          element.response === 1 ? true : false,
        );
      });
    }
    setSaveLoader("loaded");
  };

  useEffect(() => {
    if (erase) {
      setButtonColor(null);
      document.body.style.cursor = "pointer";
    } else {
      document.body.style.cursor = "context-menu";
    }
  }, [erase]);

  useEffect(() => {
    if (buttonColor) {
      setErase(false);
    }
  }, [buttonColor]);

  // Función para calcular área de polígono usando fórmula Shoelace
  const calcularArea = (points) => {
    if (points.length < 3) return 0;
    let area = 0;
    for (let i = 0; i < points.length; i++) {
      const j = (i + 1) % points.length;
      area += points[i].x * points[j].y;
      area -= points[j].x * points[i].y;
    }
    return Math.abs(area) / 2;
  };

  // Área acumulada por color de los polígonos visibles (foto + subcategoría actual).
  // Se agrupa por color y no por marca para que el área no se mueva al reasignar marcas.
  const calcularAreasPorColor = () => {
    if (!currentImage?.id || !polygonCache[currentImage.id]) return {};

    const areasByColor = {};

    getVisibleVectors(polygonCache[currentImage.id]).forEach((polygon) => {
      if (!polygon.color) return;
      const area = calcularArea(polygon.points);
      areasByColor[polygon.color] = (areasByColor[polygon.color] || 0) + area;
    });

    return areasByColor;
  };

  // Función para recalcular áreas de polígonos
  const recalcularAreas = () => {
    setPolygonAreas({ areasByColor: calcularAreasPorColor() });
  };

  const recalcularSOS = () => {
    const areasByColor = calcularAreasPorColor();
    const total = Object.values(areasByColor).reduce((acc, area) => acc + area, 0);

    const sosPercentages = {};
    Object.entries(areasByColor).forEach(([color, area]) => {
      sosPercentages[color] = total > 0 ? (area / total) * 100 : 0;
    });

    return sosPercentages;
  };

  const handleChangeOs = (id, value, isBinary = true) => {
    if (isBinary) {
      const newResponse = (prev) => {
        const exists = prev.some((item) => item.id === id);

        if (exists) {
          return prev.map((item) =>
            item.id === id
              ? {
                  ...item,
                  ...(isBinary
                    ? { response: value === true || value === "1" ? 1 : 0 }
                    : { comment: value }),
                }
              : item,
          );
        } else {
          return [
            ...prev,
            isBinary
              ? { id, response: value === true || value === "1" ? 1 : 0 }
              : { id, comment: value },
          ];
        }
      };
      setBinaryKpiCurrentImage(newResponse);
    } else {
      setComment(value);
    }
  };

  // Una imagen queda sin responder cuando no tiene ningún vector dibujado.
  const countImagesWithoutVectors = () => {
    if (!Array.isArray(listImages)) return 0;

    const vectorsByImage = type === "sosarea" ? polygonCache : lineList;

    return listImages.filter(
      (image) => (vectorsByImage[image.id] || []).length === 0,
    ).length;
  };

  const getSubCategoryName = (subCategoryKey) => (
    subCategoryKey === GENERAL_SUBCATEGORY
      ? t("teleaudit.generalSubCategory")
      : subCategories.find((subCategory) => String(subCategory.id) === subCategoryKey)?.name
        || subCategoryKey
  );

  const getRequiredBrandError = () => {
    const photosMissingRequiredBrand = getPhotosMissingRequiredBrand(
      Array.isArray(listImages) ? listImages : [],
      polygonCache,
      { getScopeKey: getSubCategoryKey, resolveBrand: resolveVectorBrand },
    );
    if (Object.keys(photosMissingRequiredBrand).length === 0) return "";

    const details = formatPhotosMissingRequiredBrand(photosMissingRequiredBrand, {
      t,
      language: i18n.language,
      scopeOrder: [
        GENERAL_SUBCATEGORY,
        ...subCategories.map((subCategory) => String(subCategory.id)),
      ],
      getScopeName: getSubCategoryName,
    });
    const requiredBrandLabel = brandOptions.find(
      (brandOption) => brandOption.value === SOS_AREA_REQUIRED_BRAND.brandId,
    )?.label;

    // Si las marcas aún no cargaron (o la id 1 no viene), no se deja el nombre en blanco.
    return requiredBrandLabel
      ? t("teleaudit.confirmModal.missingRequiredBrand", { brand: requiredBrandLabel, details })
      : t("teleaudit.confirmModal.missingRequiredBrandUnknown", { details });
  };

  const saveAllValidation = () => {
    const nextRequiredBrandError = type === "sosarea" ? getRequiredBrandError() : "";
    if (nextRequiredBrandError) {
      setRequiredBrandError(nextRequiredBrandError);
      return;
    }

    setNotAnswered(
      arrayQuestions.includes(questionType) ? countImagesWithoutVectors() : 0,
    );
    setSaving(true);
  };

  const edit = () => {
    setTeleauditStatus("pending");
  };

  const onCloseSaving = () => {
    setSaving(false);
  };

  const onClearVectorsByColor = (vectors, colorName) => (
    removeScopedVectorsByColor(
      vectors,
      colorName,
      isVisibleForSelectedSubCategory,
    )
  );

  const onClearLinesByColor = (colorName) => {
    if (currentImage && currentImage.id) {
      const updatedLines = onClearVectorsByColor(
        lineList[currentImage.id] || [],
        colorName,
      );
      setLineList({
        ...lineList,
        [currentImage.id]: updatedLines,
      });
    }
  };

  const onClearPolygonsByColor = (colorName) => {
    if (currentImage && currentImage.id) {
      const updatedPolygons = onClearVectorsByColor(
        polygonCache[currentImage.id] || [],
        colorName,
      );
      setPolygonCache({
        ...polygonCache,
        [currentImage.id]: updatedPolygons,
      });
    }
  };

  const visiblePaintItems = PAINT_ITEMS_CONFIG.slice(
    0,
    brandOptions.filter((brandOption) => brandOption.value !== 0).length,
  );

  const getAvailableCopyColor = (vectors, sourceColor) => (
    visiblePaintItems.find((item) => (
      item.key !== sourceColor
      && !vectors.some((vector) => (
        isVisibleForSelectedSubCategory(vector) && vector.color === item.key
      ))
    ))?.key
  );

  const availableCopyColors = useMemo(
    () => visiblePaintItems.reduce((availableColors, item) => ({
      ...availableColors,
      [item.key]: getAvailableCopyColor(
        type === "sosarea"
          ? polygonCache[currentImage.id] || []
          : lineList[currentImage.id] || [],
        item.key,
      ),
    }), {}),
    [brandOptions, colorOptions, currentImage.id, lineList, polygonCache, selectedSubCategory, type],
  );

  const onCopyVectorsByColor = (sourceColor) => {
    if (!currentImage?.id || teleauditStatus === "done") return;

    const vectorsByImage = type === "sosarea" ? polygonCache : lineList;
    const currentVectors = vectorsByImage[currentImage.id] || [];
    const sourceVectors = currentVectors.filter((vector) => (
      isVisibleForSelectedSubCategory(vector) && vector.color === sourceColor
    ));
    const targetColor = availableCopyColors[sourceColor];

    if (sourceVectors.length === 0 || !targetColor) return;

    const copyTimestamp = Date.now();
    const lastLineId = currentVectors.reduce(
      (maxId, vector) => Math.max(maxId, Number(vector.id) || 0),
      0,
    );
    const copiedVectors = sourceVectors.map((vector, index) => ({
      ...vector,
      id: type === "sosarea"
        ? `polygon_copy_${copyTimestamp}_${index}`
        : lastLineId + index + 1,
      color: targetColor,
      brand: 0,
      guardada: false,
      ...(type === "sosarea" ? { timestamp: new Date().toISOString() } : {}),
    }));
    const updatedVectors = [...currentVectors, ...copiedVectors];

    if (type === "sosarea") {
      setPolygonCache({
        ...polygonCache,
        [currentImage.id]: updatedVectors,
      });
    } else {
      setLineList({
        ...lineList,
        [currentImage.id]: updatedVectors,
      });
    }
  };

  const onClearAllVectors = () => {
    if (!currentImage?.id || teleauditStatus === "done") return;

    const vectorsByImage = type === "sosarea" ? polygonCache : lineList;
    const updatedVectors = (vectorsByImage[currentImage.id] || []).filter(
      (vector) => !isVisibleForSelectedSubCategory(vector),
    );

    if (type === "sosarea") {
      setPolygonCache({
        ...polygonCache,
        [currentImage.id]: updatedVectors,
      });
      setPolygonColor(null);
    } else {
      setLineList({
        ...lineList,
        [currentImage.id]: updatedVectors,
      });
      setButtonColor(null);
    }
  };

  const handleChoiceChange = (question, choice) => {
    const position = question.position;
    var choiceId = choice.id;
    var nextQuestionId = question.OriginalQuestionLogics.find(
      (l) => l.questionChoiceId === choiceId || l.questionChoiceId === null,
    ).nextQuestionId;

    var questionShow = true;
    const questionReview = questions.map((q) => {
      if (q.position > position) {
        questionShow = false;
      }
      if (question === q) {
        questionShow = true;
      }
      if (q.id === nextQuestionId) {
        questionShow = true;
        if (q.OriginalQuestionLogics.length === 1) {
          nextQuestionId = q.OriginalQuestionLogics[0].nextQuestionId;
        }
      }
      return { ...q, show: questionShow };
    });
    if (nextQuestionId === null) {
      setShowSaveTest(true);
    }
    setQuestions(questionReview);
  };
  const questionTranslatorType = (type) => {
    switch (type) {
      case "content":
        return <b>{t("qa.questionResponseView.questionTypes.content")}</b>;
      case "image":
        return <b>{t("qa.questionResponseView.questionTypes.image")}</b>;
      case "end page":
        return <b>{t("qa.questionResponseView.questionTypes.endPage")}</b>;
      case "long answer":
        return <b>{t("qa.questionResponseView.questionTypes.longAnswer")}</b>;
      case "numeric answer":
        return (
          <b>{t("qa.questionResponseView.questionTypes.numericAnswer")}</b>
        );
      case "nps question":
        return <b>{t("qa.questionResponseView.questionTypes.npsQuestion")}</b>;
      case "drop down menu":
        return <b>{t("qa.questionResponseView.questionTypes.dropDownMenu")}</b>;
      case "simple selection":
        return (
          <b>{t("qa.questionResponseView.questionTypes.simpleSelection")}</b>
        );
      case "satisfaction":
        return <b>{t("qa.questionResponseView.questionTypes.satisfaction")}</b>;
      case "short answer":
        return <b>{t("qa.questionResponseView.questionTypes.shortAnswer")}</b>;
      case "short-text":
        return <b>{t("qa.questionResponseView.questionTypes.shortText")}</b>;
      case "signature question":
        return <b>{t("qa.questionResponseView.questionTypes.signature")}</b>;
      case "text":
        return <b>{t("qa.questionResponseView.questionTypes.text")}</b>;
      case "multiple selection":
        return (
          <b>{t("qa.questionResponseView.questionTypes.multipleSelection")}</b>
        );
      case "yes/no question":
        return (
          <b>{t("qa.questionResponseView.questionTypes.yesNoQuestion")}</b>
        );
      case "welcome page":
        return <b>{t("qa.questionResponseView.questionTypes.welcomePage")}</b>;
      case "multiple image question":
        return (
          <b>
            {t("qa.questionResponseView.questionTypes.multipleImageQuestion")}
          </b>
        );
      case "date":
        return <b>{t("qa.questionResponseView.questionTypes.date")}</b>;
      case "barcode question":
        return <b>{t("qa.questionResponseView.questionTypes.barcode")}</b>;
      case "decimal answer":
        return <b>{t("qa.questionResponseView.questionTypes.decimal")}</b>;
      case "price":
        return <b>{t("qa.questionResponseView.questionTypes.price")}</b>;
      default:
        return <b>{t("qa.questionResponseView.questionTypes.default")}</b>;
    }
  };

  return (
    <div className={styles.content}>
      <Grid container style={{ height: "100vh" }} spacing={4}>
        <Grid
          item
          xs={7}
          style={{
            height: "100%",
            overflowY: "auto",
            overflowX: "hidden",
            flexBasis: "45%",
            maxWidth: "45%",
          }}
        >
          <div className={styles.header}>
            <Box sx={{ width: "100%" }}>
              <Typography variant="h1" gutterBottom className={styles.title}>
                {t("teleaudit.title")}
              </Typography>
              <Typography variant="h4" className={styles.title}>
                {t("teleaudit.subtitle")}
                {listImages.length}
                {listImages.length === 1
                  ? t("teleaudit.image")
                  : t("teleaudit.images")}
              </Typography>
            </Box>
          </div>
          <Grid
            container
            direction="column"
            alignItems="flex-start"
            spacing={0}
          >
            {/* Company Card */}
            <Grid
              item
              container
              className={styles.companyCard}
              direction="column"
              alignItems="left"
              style={{ gap: "16px" }}
            >
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"left"}
                sx={{
                  width: "100%",
                  gap: "16px",
                  flexDirection: "column",
                }}
              >
                {/* Company */}
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                >
                  <Box mr={2}>
                    {companyLogo ? (
                      <img
                        alt="company-logo"
                        src={companyLogo}
                        width="auto"
                        height="70px"
                        objecFit="cover"
                      />
                    ) : null}
                  </Box>

                  <Box>
                    <Typography variant="h2">{companyName}</Typography>
                    <Typography variant="h4">
                      {questionResponse &&
                      questionResponse.SurveyResponse.TaskInstance.Category
                        ? questionResponse.SurveyResponse.TaskInstance.Category
                            .name
                        : t("teleaudit.noCategory")}
                    </Typography>
                  </Box>
                </Box>

                {/* Response Information */}
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                >
                  <Box mr={1}>
                    <AssignmentIcon color="primary" fontSize="large" />
                  </Box>
                  <Box>
                    <Typography variant="h2">
                      {questionResponse
                        ? questionResponse.Question.title
                        : null}
                    </Typography>
                    <Typography variant="h4">
                      ID: {questionResponseId}
                    </Typography>
                  </Box>
                </Box>
              </Box>

              <Divider
                orientation="horizontal"
                style={{ width: "100%" }}
              />

              <Box
                display={"flex"}
                justifyContent={"space-between"}
                alignItems={"center"}
                style={{ width: "100%", gap: "16px" }}
              >
                {/* Survey */}
                <Box
                  display={"flex"}
                  flexDirection={"row"}
                  alignItems={"center"}
                >
                  <Box mr={1}>
                    <RateReviewOutlinedIcon color="primary" fontSize="large" />
                  </Box>
                  <Box>
                    <Typography variant="h4">
                      {questionResponse
                        ? "ID Resp: " + questionResponse.surveyResponseId
                        : ""}
                    </Typography>
                    <Typography variant="h2">
                      {questionResponse && questionResponse.SurveyResponse.Survey
                        ? questionResponse.SurveyResponse.Survey.title
                        : ""}
                    </Typography>
                    <Typography variant="h4">
                      {questionResponse && questionResponse.SurveyResponse.Survey
                        ? questionResponse.SurveyResponse.Survey.type
                        : ""}
                    </Typography>
                  </Box>
                </Box>

                {/* Question reference image */}
                <ReferenceImage
                  imageUrl={
                    questionResponse && questionResponse.Question
                      ? questionResponse.Question.imageUrl
                      : null
                  }
                  title={
                    questionResponse && questionResponse.Question
                      ? questionResponse.Question.title
                      : ""
                  }
                />
              </Box>
            </Grid>

            {/* Navigations Buttons */}
            <Grid
              item
              container
              direction="row"
              alignItems="center"
              style={{ marginTop: "24px" }}
              spacing={2}
            >
              <Box mr={2}>
                <Button
                  align="right"
                  id="back-btn"
                  text={t("teleaudit.buttons.back")}
                  variant="contained"
                  height="40px"
                  width="170px"
                  backgroundColor="theme-custom-solidButtonBackground"
                  color="theme-custom-solidButtonText"
                  borderRadius="10px"
                  component={Link}
                  to={`/teleaudits/${taskResponseId}/${type}`}
                />
              </Box>
              <Box>
                {teleauditStatus === "done" &&
                  (type === "sos" || type === "sosarea" || type === "os") && (
                    <Button
                      id="edit-btn"
                      text={t("teleaudit.buttons.edit")}
                      variant="contained"
                      height="40px"
                      width="170px"
                      backgroundColor="theme-custom-solidButtonBackground"
                      color="theme-custom-solidButtonText"
                      borderRadius="10px"
                      onClick={() => {
                        edit();
                      }}
                    />
                  )}
              </Box>
              <Box>
                {teleauditStatus === "pending" &&
                  (type === "sos" || type === "sosarea" || type === "os") && (
                    <Button
                      id="save-all-btn"
                      text={t("teleaudit.buttons.saveAll")}
                      variant="contained"
                      height="40px"
                      width="170px"
                      backgroundColor="theme-custom-solidButtonBackground"
                      color="theme-custom-solidButtonText"
                      borderRadius="10px"
                      onClick={() => {
                        saveAllValidation();
                      }}
                    />
                  )}
              </Box>
            </Grid>
          </Grid>

          <Box style={{ paddingTop: "3%" }}>
            {teleauditKpis && arrayQuestions.includes(questionType) ? (
              <>
                {/* Metrics */}
                <Box>
                  {(type === "sos" || type === "sosarea") && (
                    <Tabs
                      value={selectedSubCategory}
                      onChange={handleSubCategoryChange}
                      indicatorColor="primary"
                      textColor="primary"
                      variant="scrollable"
                      scrollButtons="auto"
                      style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.15)" }}
                    >
                      <Tab
                        value={GENERAL_SUBCATEGORY}
                        label={<strong>General</strong>}
                      />
                      {subCategories.map((subCategory) => (
                        <Tab
                          key={subCategory.id}
                          value={subCategory.id}
                          label={<strong>{subCategory.name}</strong>}
                        />
                      ))}
                    </Tabs>
                  )}
                  {teleauditKpis &&
                  !loading &&
                  (type === "sos" || type === "sosarea") ? (
                    <BinaryTable teleauditKpis={teleauditKpis} />
                  ) : null}
                </Box>

                <Box mb={2}>
                  {/* SOS AREA */}
                  {type === "sosarea" && (
                    <PolygonAreasTable
                      polygonAreas={polygonAreas}
                      polygonColor={polygonColor}
                      setPolygonColor={setPolygonColor}
                      onClearPolygonByColor={onClearPolygonsByColor}
                      onClearAllVectors={onClearAllVectors}
                      onCopyVectorsByColor={onCopyVectorsByColor}
                      availableCopyColors={availableCopyColors}
                      teleauditStatus={teleauditStatus}
                      colorOptions={colorOptions}
                      brandOptions={brandOptions}
                      setColorOptions={setColorOptions}
                      sosPercentages={recalcularSOS()}
                    />
                  )}
                </Box>

                {/* Graphics */}
                <Box mb={2}>
                  {type === "sos" && (
                    <ColorButtons
                      selectedColor={buttonColor}
                      onColorSelect={setButtonColor}
                      onClearLinesByColor={onClearLinesByColor}
                      onClearAllVectors={onClearAllVectors}
                      onCopyVectorsByColor={onCopyVectorsByColor}
                      availableCopyColors={availableCopyColors}
                      drawingType={drawingType}
                      onDrawingTypeChange={setDrawingType}
                      lines={lines}
                      currentImageId={currentImage ? currentImage.id : null}
                      teleauditKpis={teleauditKpis}
                      switchValues={switchValues}
                      teleauditStatus={teleauditStatus}
                      onBrandOptionChange={setColorOptions}
                      initialColorOptions={colorOptions}
                      brandOptions={brandOptions}
                      productName={
                        questionResponse.SurveyResponse.Product
                          ? questionResponse.SurveyResponse.Product.name
                          : "-"
                      }
                    />
                  )}
                </Box>

                {/* Sección de Encuesta */}
                {type === "encuesta" && (
                  <SurveySection
                    questions={questions}
                    teleauditStatus={teleauditStatus}
                    answersSubmitted={answersSubmitted}
                    showSaveTest={showSaveTest}
                    questionResponse={questionResponse}
                    postSurveyTeleaudit={postSurveyTeleaudit}
                    setAnswersSubmitted={setAnswersSubmitted}
                    handleChoiceChange={handleChoiceChange}
                    questionTranslatorType={questionTranslatorType}
                    styles={styles}
                  />
                )}

                {/* Sección de On Shell */}
                {type === "os" && (
                  <Box mt={2} className={styles.questionCard}>
                    <Box
                      mt={4}
                      mb={4}
                      display="flex"
                      direction="row"
                      alignItems="center"
                    >
                      <AssignmentIcon color="primary" />
                      <Typography variant="h2">On Shelf</Typography>
                    </Box>

                    {binaryKpis.map((question, index) => {
                      const current =
                        binaryKpiCurrentImage.find(
                          (x) => x.id === question.id,
                        ) || {};

                      return (
                        <Box
                          key={question.id}
                          mb={2}
                          className={styles.questionCard}
                        >
                          <Box
                            mb={2}
                            display="flex"
                            flexDirection="column"
                            alignItems="start"
                          >
                            <Typography
                              variant="h3"
                              fontWeight="bold"
                              style={{
                                marginBottom: "8px",
                                fontSize: "14px",
                              }}
                            >
                              {question.KpiDetail.description}
                            </Typography>
                            <Typography variant="h3" fontWeight="bold">
                              {index + 1}. {question.KpiDetail.name}
                            </Typography>
                          </Box>

                          {question.KpiDetail.imageUrl && (
                            <Box mb={2}>
                              <img
                                src={question.KpiDetail.imageUrl}
                                alt={question.KpiDetail.name}
                                style={{
                                  maxWidth: '300px',
                                  maxHeight: '300px',
                                  objectFit: 'contain',
                                  borderRadius: '4px',
                                }}
                              />
                            </Box>
                          )}

                          {/* Radios de respuesta binaria */}
                          <div>
                            <label
                              style={{ display: "block", margin: "12px 0" }}
                            >
                              <input
                                type="radio"
                                disabled={
                                  teleauditStatus === "done" ? true : false
                                }
                                name={`question_${question.id}`}
                                value="1"
                                checked={current.response === 1} // 👈 controlado
                                onChange={(e) =>
                                  handleChangeOs(
                                    question.id,
                                    e.target.value,
                                    true,
                                  )
                                } // actualiza response
                                style={{ marginRight: "8px" }}
                              />
                              Si Cumple
                            </label>
                            <label
                              style={{ display: "block", margin: "12px 0" }}
                            >
                              <input
                                type="radio"
                                disabled={
                                  teleauditStatus === "done" ? true : false
                                }
                                name={`question_${question.id}`}
                                value="0"
                                checked={current.response === 0} // 👈 controlado
                                onChange={(e) =>
                                  handleChangeOs(
                                    question.id,
                                    e.target.value,
                                    true,
                                  )
                                }
                                style={{ marginRight: "8px" }}
                              />
                              No Cumple
                            </label>
                          </div>
                        </Box>
                      );
                    })}
                    <TextField
                      name={`comment`}
                      type="text"
                      placeholder="Respuesta..."
                      disabled={teleauditStatus === "done" ? true : false}
                      value={comment ?? ""} // 👈 valor específico para esta pregunta
                      onChange={(e) =>
                        handleChangeOs(null, e.target.value, false)
                      } // actualiza comment
                      style={{ width: "100%" }}
                    />
                  </Box>
                )}
              </>
            ) : null}
          </Box>
        </Grid>
        <Grid
          item
          xs={5}
          style={{
            flexBasis: "55%",
            maxWidth: "55%",
          }}
        >
          {currentImage && !loading ? (
            <>
              <Box
                mb={2}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                <SurveyImage
                  buttonColor={buttonColor}
                  lines={lines}
                  erase={erase}
                  shareType={
                    type === "sosarea" || drawingType !== "line"
                      ? "volumetric-share"
                      : "linear-share"
                  }
                  questionResponseImage={currentImage}
                  setLineList={setLineList}
                  polygonMode={polygonMode}
                  polygonCache={polygonCache}
                  setPolygonCache={setPolygonCache}
                  polygonColor={polygonColor}
                  colorOptions={colorOptions}
                  selectedSubCategoryId={selectedSubCategory}
                />
              </Box>
              <Box>
                {arrayQuestions.includes(questionType) ||
                type === "encuesta" ? (
                  <TeleauditCarousel
                    loading={loading}
                    listImages={listImages}
                    setCurrentImage={setCurrentImage}
                  />
                ) : null}
              </Box>
            </>
          ) : null}
        </Grid>
      </Grid>

      <Snackbar
        open={requiredBrandError !== ""}
        message={requiredBrandError}
        severity="error"
        onClose={() => setRequiredBrandError("")}
      />

      {saving ? (
        <Modal
          title={
            saveLoader === "" ? t("teleaudit.confirmModal.sureQuestion") : null
          }
          defaultOpen={saving}
          // setCurrentOpen={setSaving}
          setCurrentOpen={saveLoader === "loaded" ? null : setSaving}
          hideButton={true}
          hideClose={true}
          disableScroll={true}
        >
          {saveLoader === "" ? (
            <div className={styles.modalForm}>
              {notAnswered > 0 ? (
                <div align="center" className={styles.confirmModal}>
                  <Typography variant="h4" className={styles.title}>
                    {t("teleaudit.confirmModal.quantityPartOne")}
                    {notAnswered}
                    {notAnswered === 1
                      ? t("teleaudit.confirmModal.quantityUnique")
                      : t("teleaudit.confirmModal.quantityPlural")}
                    {t("teleaudit.confirmModal.quantityNotAnswered")}
                  </Typography>
                </div>
              ) : null}
              <Grid alignItems="center" spacing={1} container>
                <>
                  <Grid item xs={6}>
                    <Button
                      id="close-modal-btn"
                      onClick={onCloseSaving}
                      variant="contained"
                      backgroundColor="theme-custom-dangerButtonBackground"
                      text={t("teleaudit.buttons.back")}
                    ></Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      id="save-all-confirmed-btn"
                      onClick={saveAll}
                      backgroundColor="theme-custom-solidButtonBackground"
                      text={t("teleaudit.buttons.confirm")}
                      variant="contained"
                    ></Button>
                  </Grid>
                </>
              </Grid>
            </div>
          ) : (
            <>
              {saveLoader === "loading" ? (
                <div className={styles.modalForm}>
                  <div style={{ paddingTop: "5%" }} align="center">
                    <CircularProgress align="center" />
                  </div>
                </div>
              ) : (
                <div className={styles.secondModalForm}>
                  <div align="center" className={styles.confirmModal}>
                    <Typography
                      variant="h4"
                      className={styles.title}
                      align="center"
                    >
                      {t("teleaudit.confirmModal.success")}
                    </Typography>
                  </div>
                  <Grid alignItems="center" spacing={1} container>
                    <Grid item xs={4}></Grid>
                    <Grid
                      item
                      xs={4}
                      align="center"
                      style={{ paddingTop: "3%" }}
                    >
                      <Button
                        id="close-modal-btn"
                        variant="contained"
                        with="100%"
                        backgroundColor="theme-custom-solidButtonBackground"
                        text={t("teleaudit.confirmModal.button")}
                        component={Link}
                        to={`/teleaudits/${taskResponseId}/${type}`}
                      ></Button>
                    </Grid>
                  </Grid>
                </div>
              )}
            </>
          )}
        </Modal>
      ) : null}
    </div>
  );
};

export default TeleauditAll;
/* eslint-enable */
